/**
 * The layout that defines the size and position of the elements along the
 * stack’s orientation.
 */
export var StackDistribution = {
  EqualSpacing: 'equalSpacing',
  EqualCentering: 'equalCentering',
  Fill: 'fill',
  FillEqually: 'fillEqually',
  FillProportionally: 'fillProportionally'
};